{
  "name": "admin-aquaforms",
  "version": "1.27.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run generate-version && ng build",
    "build:dev": "npm run generate-version && ng build --configuration development",
    "build:qa": "npm run generate-version && ng build --configuration qa",
    "build:prod": "npm run generate-version && ng build --configuration production",
    "generate-version": "node scripts/generate-version.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test",
    "test:headless": "ng test",
    "test:coverage": "ng test",
    "test:coverage:check": "npm run test:coverage && node scripts/check-coverage.js",
    "security:audit": "npm audit --audit-level=moderate",
    "security:audit:fix": "npm audit fix",
    "test:integration": "npm run test:coverage && npm run security:audit",
    "lint": "ng lint || echo 'Linting completed with warnings'",
    "lint:strict": "ng lint",
    "build:verify": "npm run build:dev",
    "test:phase2": "npm run build:verify && npm run test:coverage:check && npm run security:audit",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/cdk": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/material": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "@fontsource/material-icons": "^5.2.7",
    "@fontsource/roboto": "^5.2.9",
    "@fontsource/roboto-mono": "^5.2.8",
    "aws-amplify": "^6.15.3",
    "aws-rum-web": "^2.0.0",
    "buffer": "^6.0.3",
    "jwt-decode": "^4.0.0",
    "process": "^0.11.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^9.0.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@types/node": "^20.13.0",
    "@types/uuid": "^9.0.8",
    "angular-eslint": "21.2.0",
    "eslint": "^9.39.2",
    "husky": "^9.1.7",
    "jsdom": "^28.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.50.1",
    "vitest": "^4.0.18"
  }
}
